export const NO_MATCHES_STATUS = 204
